import { useState, useEffect, useMemo } from "react";
import { Input } from "@/components/ui/input";

export function Autocomplete({ value, onChange, options = [], placeholder, testid, ...props }) {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState(value || "");

  useEffect(() => { setQ(value || ""); }, [value]);

  const norm = (s) =>
    (s || "").toString().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");

  const filtered = useMemo(() => {
    const s = norm(q);
    return options.filter((o) => norm(o).includes(s)).slice(0, 12);
  }, [q, options]);

  return (
    <div className="relative">
      <Input
        value={q}
        placeholder={placeholder}
        data-testid={testid}
        autoComplete="off"
        onChange={(e) => { setQ(e.target.value); onChange(e.target.value); setOpen(true); }}
        onFocus={() => setOpen(true)}
        onBlur={() => setTimeout(() => setOpen(false), 150)}
        {...props}
      />
      {open && filtered.length > 0 && (
        <div className="absolute z-[60] mt-1 w-full max-h-52 overflow-auto rounded-md border border-border bg-popover shadow-xl" data-testid={`${testid}-list`}>
          {filtered.map((o, idx) => (
            <button
              type="button"
              key={o}
              className="w-full text-left px-3 py-1.5 text-sm hover:bg-secondary"
              onMouseDown={(e) => { e.preventDefault(); onChange(o); setQ(o); setOpen(false); }}
              data-testid={`${testid}-option-${idx}`}
            >
              {o}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
